import { render, staticRenderFns } from "./AgeTechServiceModify.vue?vue&type=template&id=f7fb5eda&scoped=true"
import script from "./AgeTechServiceModify.vue?vue&type=script&lang=js"
export * from "./AgeTechServiceModify.vue?vue&type=script&lang=js"
import style0 from "./AgeTechServiceModify.vue?vue&type=style&index=0&id=f7fb5eda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fb5eda",
  null
  
)

export default component.exports